const getImage = (wrapper) => {
  if (wrapper?.imageMap) {
    return wrapper.imageMap;
  }
  if (wrapper?.banner) {
    return wrapper.banner;
  }
  if (wrapper?.logo) {
    return wrapper.logo;
  }
  if (wrapper?.image) {
    return wrapper.image;
  }

  return undefined;
};

export default getImage;
